





























import {Component, Prop, Vue} from "vue-property-decorator";
import axios from "axios";

@Component({components: {}})
export default class audit_osc extends Vue {
    $config: any;
    osc = {
        percent: 0,
        current: 0
    };
    ws = 0;

    @Prop({
        type: Boolean,
        required: true,
        default: false
    }) public is_open !: boolean;

    get open() {
        return this.is_open
    }

    set open(vl) {
    }

    get work_id() {
        return this.$store.state.osc_id
    }

    oscClose() {
        clearInterval(this.ws);
        this.$emit("cancel")
    }

    oscKill() {
        axios.delete(`${this.$config.url}/audit/fetch_osc/${this.work_id}`)
            .then(res => {
                this.$config.notice(res.data);
                this.oscClose()
            })
            .catch(err => {
                this.$config.err_notice(this,err);
                this.oscClose()
            })
    }

    openOSC() {
        if (this.open) {
            axios.get(`${this.$config.url}/audit/fetch_osc/${this.work_id}`)
                .then(res => {
                    this.osc.percent = res.data.p;
                    this.osc.current = res.data.s;
                })
                .catch(err => this.$config.err_notice(this,err))
        }
    }

    mounted() {
        let vm = this;
        this.ws = setInterval(function () {
            vm.openOSC()
        }, 3000)
    }
}
